__turbopack_context__.v({
  "buttons": "MobileScreens-module-scss-module__--V2iq__buttons",
  "content": "MobileScreens-module-scss-module__--V2iq__content",
  "divider": "MobileScreens-module-scss-module__--V2iq__divider",
  "linkWrapper": "MobileScreens-module-scss-module__--V2iq__linkWrapper",
  "mobileMenuStickBottom": "MobileScreens-module-scss-module__--V2iq__mobileMenuStickBottom",
  "mobileMenuTextButton": "MobileScreens-module-scss-module__--V2iq__mobileMenuTextButton",
  "topGradient": "MobileScreens-module-scss-module__--V2iq__topGradient",
});
